import { render, staticRenderFns } from "./DataProperties.vue?vue&type=template&id=935edd04"
import script from "./DataProperties.vue?vue&type=script&lang=js"
export * from "./DataProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports